/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function RunbooksIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path fillRule="evenodd" clipRule="evenodd" d="M15.2 4c-3.31 0-6.52 2.7-7.172 6H5a1 1 0 1 0 0 2h16a1 1 0 1 1 0 2H7a1 1 0 0 0-.143 1.99l-.002.01H19a1 1 0 1 1 0 2H5a1 1 0 1 0 0 2h12a1 1 0 1 1 0 2H5.681l-1.565 8c-.652 3.3 1.505 6 4.865 6h20.062c1.053 0 2.157-.9 2.408-2 .2-1.05-.552-2-1.605-2l.802-4c1.053 0 2.157-.9 2.408-2l3.912-20c.2-1.05-.552-2-1.605-2zm-4.664 24h16.05l-.803 4H9.733c-1.103 0-1.855-.9-1.604-2 .2-1.05 1.253-2 2.407-2"/>}
        </IconWrapper>);
}
